export const RESOURCE_AREA_HEADER = 'Assets';
export const RESOURCE_AREA_WIDTH = {
    sm: '100px',
    md: '180px'
};
